import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@/components/Dialog';
import { Table, Column, Button } from '@tencent/spaui';
import DateTime from '@/components/DateTime';
import UserInfo from '@/business-components/sale/UserInfo';
import _ from 'lodash';
import { getMessage } from '@/utils/MessageUtils';
import { connect } from 'react-redux';
import LinkButton from '@/components/LinkButton';
import PotentialStatus from '@/components/PotentialStatus';
import { withRouter } from 'react-router-dom';
import perms from '@/common/permissions/sale/perms';
import FollowRecord from '../FollowRecord/index';
import './index.less';

const PROGRESS_STATUS_2_TYPE = {
  PROGRESS_STATUS_LEAD: 'leads',
  PROGRESS_STATUS_POTENTIAL: 'potentials',
  PROGRESS_STATUS_ORDER: 'orders',
};

@withRouter
class DialOutModal extends React.Component {
  static propTypes = {
    loginStatus: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
    historyList: PropTypes.array,
    grayList: PropTypes.object,
    dialOutRule: PropTypes.object,
    highSeaRule: PropTypes.object,
    leadHighSeaRule: PropTypes.object,
    leadList: PropTypes.array,
    contactPhone: PropTypes.string.isRequired,
    makeCall: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    autoDialOut: PropTypes.bool.isRequired,
    potentialHighSeaMaxLimitRule: PropTypes.object, // 商机公海外呼总限制
    leadHighSeaMaxLimitRule: PropTypes.object, // 线索公海外呼总限制
  }

  constructor(props) {
    super(props);
    this.state = {
      called: _.isEmpty(props.leadList) || props.leadList.length === 1 ? props.autoDialOut : false,
      selectedId: '',
    };
  }

  state = {}

  render() {
    const { status, grayList, dialOutRule, highSeaRule, leadHighSeaRule, leadList, contactPhone, onClose, loginStatus, potentialHighSeaMaxLimitRule, leadHighSeaMaxLimitRule, mobileLead, leadDetail } = this.props;
    const { called, selectedId } = this.state;
    const phoneNumber = _.includes(contactPhone, '#') ? contactPhone.substr(0, contactPhone.indexOf('#')) : contactPhone;
    let notMineRule;
    if (leadList && leadList.length === 1) {
      // 用户通过外呼面板拨打，且只有一条关联线索时直接拨打
      const lead = _.first(leadList);
      if (!lead.operateFlag && lead.ownerId !== loginStatus.userId && lead.visibilityScope !== 'VISIBILITY_SCOPE_PUBLIC' && lead.cleaningStatus !== 'CLEANING_STATUS_INVALID') {
        // 禁止拨打别人跟进的线索
        notMineRule = true;
      }
    }
    //   } else if (!grayList && !dialOutRule && !highSeaRule && !leadHighSeaRule && !leadHighSeaMaxLimitRule && !potentialHighSeaMaxLimitRule) {
    //     const selectedId = lead.leadId;
    //     const showIdDialogInfo = {
    //       type: PROGRESS_STATUS_2_TYPE[lead.progressStatus],
    //       id: selectedId,
    //     };
    //     console.log('第三步分支---4，【触发拨打电话 makecall函数】');
    //     makeCall(lead.leadId, showIdDialogInfo);
    //   }
    // }
    // 外呼限制必须关联线索权限判断
    const grayPermWithLeads = _.includes(loginStatus?.grayPermissions, perms.GRAY_CALL_CENTER_DIAL_OUT_RELATION_LEAD) && !mobileLead;

    return (
      <Dialog
        modalClassName='no-cover tccc-dialout-dialog-container'
        moveable={true}
        style={{ zIndex: 1 }}
        hideScrollBar={false}
        show={true}
        title={called ? `拨打 ${phoneNumber}` : `外呼确认 ${phoneNumber}`}
        className={'DialOutModal'}
        onClose={onClose}
        onCancel={onClose}
        onSubmit={this.handleSubmit}
        disabled={status === 'PHONE_STATUS_BLACK' || called || (leadList && !selectedId) || grayPermWithLeads}
        submitLabel={'继续呼叫'}
        submitBsStyle={status === 'PHONE_STATUS_WHITE' ? 'primary' : 'default'}
        cancelLabel={called ? '关闭' : '放弃呼叫'}
        submitButton={!called}
        cancelBsStyle={status !== 'PHONE_STATUS_WHITE' && !called ? 'warning' : 'default'}
      >
        {
          !grayList && grayPermWithLeads ? this.renderNoLeadLimit(phoneNumber)
            :  <React.Fragment>
              {leadList ? this.renderLeadList(leadList) : this.renderNonLead()}
              {grayList && this.renderGrayList(grayList)}
              {dialOutRule && this.renderDialOutRule(dialOutRule)}
              {(highSeaRule || leadHighSeaRule || leadHighSeaMaxLimitRule || potentialHighSeaMaxLimitRule) && this.renderHighSeaRule(highSeaRule, leadHighSeaRule, leadHighSeaMaxLimitRule, potentialHighSeaMaxLimitRule)}
              {notMineRule && this.renderNotMineRule()}
            </React.Fragment>
        }
        <FollowRecord
          show={called}
          leadDetail={leadDetail}
          rerenderDialog={(data) => {
            this.setState({ ...this.state });
            if (data?.close) {
              onClose();
            }
          }}/>
      </Dialog>
    );
  }

  /**
   * 外呼限制，必须关联线索
   */
  renderNoLeadLimit = (phoneNumber) => {
    return (
      <p>当前外呼限制必须关联线索，检测到该号码无匹配线索，请点击 <Button onClick={() => this.handleCreateLead(phoneNumber)} displayType="primary"> 新建线索</Button></p>
    );
  }

  handleCreateLead = (phoneNumber) => {
    this.props.history.push({ pathname: '/leads/create', state: { params: { Caller: phoneNumber } } });
    this.props.onClose();
  }

  renderLeadList(leadList) {
    const { selectedId } = this.state;
    return (
      <React.Fragment>
        {leadList.length > 1 && this.renderWarning('请选中需要外呼跟进的线索ID')}
        <Table className={'diaout-table-container'} data={leadList} setRowAndColSpan={this.handleTableRowAndColSpan}>
          {!this.state.called && <Column type="optional" target="leadId" value={selectedId} disabledValue={this.canOptional(leadList)} disabledValueConfig={this.disabledConfig(this.canOptional(leadList))} onOptionalChange={this.handleChangeOptional} />}
          <Column name="leadId" render={this.renderLeadId}>
            线索 ID
          </Column>
          <Column name="companyName">公司名称</Column>
          <Column name="ownerId" render={this.renderOwner}>
            跟进销售
          </Column>
          <Column name="progressStatus" render={this.renderProgressStatus}>
            阶段
          </Column>
          <Column name="adPlatformType" render={this.renderAdPlatformType}>
            推广目标
          </Column>
          <Column name="potentialStatus" render={this.renderPotentialStatus}>
            商机状态
          </Column>
          <Column name="visibilityScope" render={this.renderVisibilityScope}>
            是否公私海
          </Column>
          <Column name="count" render={this.renderHistory}>
            最近一个月联系次数
          </Column>
          <Column name="list" render={this.renderHistory}>
            最近联系时间
          </Column>
        </Table>
      </React.Fragment>
    );
  }

  renderNonLead() {
    return (
      <Table data={[{}]}>
        <Column name="count" render={this.renderHistory}>
          最近一个月联系次数
        </Column>
        <Column name="list" render={this.renderHistory}>
          最近联系时间
        </Column>
      </Table>
    );
  }

  renderGrayList(grayList) {
    return this.renderWarning(
      '该电话号码已经被黑名单限制！可能会造成客户反感和投诉！',
      <ul>
        <li>
          标注人：
          <UserInfo userId={grayList.markerId} />
        </li>
        <li>
          标注时间：
          <DateTime dateTime={grayList.dateTime} />
        </li>
        <li>备注：{grayList.memo}</li>
      </ul>,
    );
  }

  renderDialOutRule(dialOutRule) {
    return this.renderWarning(
      '该电话号码已经超过今日拨打限制！可能会造成客户反感和投诉！',
      <ul>
        <li>
          外呼拨打限制：每 {dialOutRule.daysOfDialOutStatPeriod} 天不超过 {dialOutRule.maxDialOutInStatPeriod} 次
        </li>
      </ul>,
    );
  }

  renderHighSeaRule(highSeaRule, leadHighSeaRule, leadHighSeaMaxLimitRule, potentialHighSeaMaxLimitRule) {
    return this.renderWarning(
      '该线索/商机已超出公海拨打次数限制！可能会造成客户反馈和投诉！',
      <ul>
        {highSeaRule && (
          <li>
            商机公海拨打限制：公海池每条商机允许每 {highSeaRule.daysOfDialOutStatPeriod} 天外呼电话联系 {highSeaRule.maxDialOutInStatPeriod} 次
          </li>
        )}
        {leadHighSeaRule && (
          <li>
            线索公海拨打限制：公海池每条线索允许每 {leadHighSeaRule.daysOfDialOutStatPeriod} 天外呼电话联系 {leadHighSeaRule.maxDialOutInStatPeriod} 次
          </li>
        )}
        {leadHighSeaMaxLimitRule && (
          <li>
            线索公海拨打限制：总次数限制允许 {leadHighSeaMaxLimitRule.daysOfMaxDialOutStatPeriod} 天内外呼电话联系 {leadHighSeaMaxLimitRule.maxLimitDialOutInStatPeriod} 次
          </li>
        )}
        {potentialHighSeaMaxLimitRule && (
          <li>
            商机公海拨打限制：总次数限制允许 {potentialHighSeaMaxLimitRule.daysOfMaxDialOutStatPeriod} 天内外呼电话联系 {potentialHighSeaMaxLimitRule.maxLimitDialOutInStatPeriod} 次
          </li>
        )}
      </ul>,
    );
  }

  renderNotMineRule = () => this.renderWarning('该电话号码在他人商机联系人中，禁止进行外呼')

  renderWarning(title, message) {
    return (
      <div className={'warning'}>
        <h5>{title}</h5>
        {message}
      </div>
    );
  }

  disabledConfig = (leadIdList) => {
    return _.zipObject(
      _.map(leadIdList, (id) => id),
      _.map(leadIdList, (id) => <span>该线索为他人跟进线索</span>),
    );
  }

  canOptional = (leadList) => {
    const { loginStatus } = this.props;
    return _.map(
      _.filter(leadList, (lead) => lead.visibilityScope === 'VISIBILITY_SCOPE_PRIVATE' && lead.ownerId !== loginStatus.userId && !lead.operateFlag),
      (lead) => lead.leadId,
    );
  }

  handleChangeOptional = (event, value, multiple) => {
    this.setState({
      selectedId: value,
    });
  }

  renderLeadId = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value) {
      if (data.viewable) {
        switch (data.progressStatus) {
          case 'PROGRESS_STATUS_LEAD':
            return <LinkButton to={{ pathname: `/leads/${value}` }}>{value}</LinkButton>;
          case 'PROGRESS_STATUS_POTENTIAL':
          case 'PROGRESS_STATUS_ORDER':
            return <LinkButton to={{ pathname: `/potentials/${value}` }}>{value}</LinkButton>;
          default:
            break;
        }
      }
      return value;
    }
    return '-';
  }

  renderOwner = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value) {
      return <UserInfo userId={value} />;
    }
    return '-';
  }

  renderProgressStatus = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value) {
      return getMessage(value, 'ProgressStatus');
    }
    return '-';
  }

  renderAdPlatformType = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value) {
      return getMessage(value, 'AdPlatformType');
    }
    return '-';
  }

  renderPotentialStatus = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value) {
      return <PotentialStatus potentialStatus={data.potentialStatus} transactionProbability={data.transactionProbability} />;
    }
    return '-';
  }

  renderVisibilityScope = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }
    if (value) {
      return getMessage(value, 'VisibilityScope');
    }
    return '-';
  }

  renderHistory = (type, name, value, data) => {
    if (type === 'head') {
      return value;
    }

    const { historyList } = this.props;
    if (historyList) {
      switch (name) {
        case 'count':
          return historyList.length;
        case 'list':
          return (
            <ul>
              {_.map(_.take(_.reverse(_.sortBy(historyList, (h) => h.time)), 5), (h, i) => (
                <li key={i}>
                  <DateTime dateTime={h.time} />
                </li>
              ))}
            </ul>
          );
        default:
          break;
      }
    }

    switch (name) {
      case 'count':
        return 0;
      case 'list':
        return '无';
      default:
        break;
    }
    return '-';
  }

  handleTableRowAndColSpan = (type, name, value, rowIndex, colIndex) => {
    if (type === 'data') {
      if (colIndex >= 8) {
        return {
          colSpan: 1,
          rowSpan: this.props.leadList.length,
        };
      }
    }
  }

  // 继续拨打，设置called状态，并回调拨打事件以及当前弹出框关闭事件
  handleSubmit = () => {
    const { makeCall, onClose } = this.props;
    let showIdDialogInfo = {};
    this.setState(
      {
        called: true,
      },
      () => {
        const selectedId = this.state.selectedId;
        if (selectedId) {
          const item = this.props.leadList?.find((item) => item.leadId === selectedId);
          const {
            progressStatus,
          } = item;
          showIdDialogInfo = {
            type: PROGRESS_STATUS_2_TYPE[progressStatus],
            id: selectedId,
          };
        }
        makeCall(selectedId, showIdDialogInfo);
        onClose();
      },
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    loginStatus: state.loginStatus,
  };
}

export default connect(mapStateToProps)(DialOutModal);

// export default DialOutModal;
